import { render } from "./CloneScenario.vue?vue&type=template&id=12be4fd6&ts=true"
import script from "./CloneScenario.vue?vue&type=script&lang=ts"
export * from "./CloneScenario.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__